import React from 'react';
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';
import ImageComparison from '../components/ImageComparison';
import ContentDisplay from '../components/ContentDisplay';

const RetouchingPage = ({ variant = 'light' }) => {
  const { t } = useTranslation();
  const isDark = variant === 'dark';

  const tabData = {
    id: 'retouching',
    label: t('navigation.retouching'),
    title: t('pages.retouching.title'),
    subtitle: t('pages.retouching.subtitle')
  };

  return (
    <motion.div
      className="container mx-auto px-4 py-6 lg:py-10"
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -20 }}
      transition={{ duration: 0.6 }}
    >
      <div className="mb-8 lg:mb-12">
        <ContentDisplay activeTab="retouching" tabData={[tabData]} variant={variant} />
      </div>

      <div className="mb-8 lg:mb-12">
        <div className="max-w-7xl mx-auto">
          <div className="space-y-8">
            <div className="space-y-5 max-w-4xl mx-auto">
              <ImageComparison
                beforeImage="/1_before.jpeg"
                afterImage="/1_after.jpg"
                className="mx-auto w-full"
                initialAspectRatio={1080 / 733}
                maxWidthPx={800}
                maxWidthPxMd={700}
                minWidthPx={320}
                maxHeightVh={66}
                mediumScreenMaxHeightVh={60}
                smallScreenMaxHeightVh={54}
              />
            </div>
          </div>
        </div>
      </div>
    </motion.div>
  );
};

export default RetouchingPage;